import React from 'react';
import { useTranslation } from 'react-i18next';

export default function QuestionReviewCard({
    question,
    index,
    hasAnswer = false,
    onOpen
}) {
    const { t } = useTranslation('common');

    if (!question) return null;

    // Difficulty Level
    const rawLevel = question.Level?.Id ?? question.Level ?? 1;
    let levelKey = 'easy';
    if (typeof rawLevel === 'number') {
        levelKey = rawLevel <= 1 ? 'easy' : rawLevel === 2 ? 'medium' : 'hard';
    } else {
        const s = String(rawLevel).toLowerCase();
        if (s.startsWith('m') || s.includes('متوسط')) levelKey = 'medium';
        else if (s.startsWith('h') || s.includes('صعب')) levelKey = 'hard';
        else levelKey = 'easy';
    }

    const levelLabel = levelKey === 'easy'
        ? (t('Pages.Lessons.Summary.levelEasy') || 'سهل')
        : levelKey === 'medium'
            ? (t('Pages.Lessons.Summary.levelMedium') || 'متوسط')
            : (t('Pages.Lessons.Summary.levelHard') || 'صعب');

    return (
        <div
            className={`finish-q-card ${hasAnswer ? 'is-answered' : 'is-unanswered'}`}
            onClick={() => onOpen && onOpen(question.Id)}
            title={`انقر لفتح السؤال ${index + 1} ومراجعته`}
        >
            <div className="finish-q-card-header">
                <div className="d-flex align-items-center" style={{ gap: '0.4rem' }}>
                    <span className="finish-q-num-badge">
                        <i className="fas fa-question-circle text-primary"></i>
                        <span>{t('Pages.Lessons.Questions.forms.Question') || 'السؤال '} {index + 1}</span>
                    </span>
                    <span className={`finish-q-level-badge ${levelKey}`}>
                        <i className={`fas ${levelKey === 'easy' ? 'fa-feather-alt' : levelKey === 'medium' ? 'fa-tachometer-alt' : 'fa-fire-alt'}`}></i>
                        <span>{levelLabel}</span>
                    </span>
                </div>

                {question.Mark !== undefined && (
                    <span className="badge badge-light text-muted font-weight-bold" style={{ fontSize: '0.72rem' }}>
                        {t('Pages.Lessons.Questions.forms.QuestionMark.title') || 'علامة السؤال'}: {question.Mark}
                    </span>
                )}
            </div>

            <div
                className="finish-q-title"
                dangerouslySetInnerHTML={{ __html: question.Name }}
            />

            <div className="finish-q-footer">
                {hasAnswer ? (
                    <span className="finish-q-status answered">
                        <i className="fas fa-check-circle"></i>
                        <span>تمت الإجابة</span>
                    </span>
                ) : (
                    <span className="finish-q-status unanswered">
                        <i className="fas fa-exclamation-triangle"></i>
                        <span>لم يتم الحل بعد</span>
                    </span>
                )}

                <span className="finish-q-action-hint">
                    <span>مراجعة الحل</span>
                    <i className="fas fa-arrow-left"></i>
                </span>
            </div>
        </div>
    );
}
